import { render, staticRenderFns } from "./MesaNewMesaVisu.vue?vue&type=template&id=006b7d70&scoped=true"
import script from "./MesaNewMesaVisu.vue?vue&type=script&lang=js"
export * from "./MesaNewMesaVisu.vue?vue&type=script&lang=js"
import style0 from "./MesaNewMesaVisu.vue?vue&type=style&index=0&id=006b7d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b7d70",
  null
  
)

export default component.exports